import { LocationConfig } from './LocationConfig';
import { LocationService } from './LocationService';
export function clientLocationPlugin(location) {
  return function (router) {
    router.locationConfig = new LocationConfig(location);
    router.locationService = new LocationService(location);
    return {
      name: 'WixUIRouterClientLocation'
    };
  };
}
//# sourceMappingURL=plugin.js.map